<style scoped>
	.v-alert{
		border: 1px solid #ccc;
	}
</style>
<template>
<v-alert class="pa-3 mb-0" colored-border border="left" :color="color(task)">
	<p  style="font-size: 0.9em" class="mr-5"><b>{{ task.title }}</b></p> 
	<v-btn icon x-small absolute right top @click="$emit('clicked')"><v-icon small>mdi-pencil</v-icon></v-btn>
	<div>
		<small>{{ snippet }}</small>
	</div>
	<div class="mt-2">
		<v-chip small dense class="mr-2" v-for="view in task.view" :key="view">{{view}}</v-chip>
		<v-badge class="float-right" v-if="notes" :content="notes" :value="notes" color="green" overlap>
			<v-icon>mdi-comment</v-icon>
		</v-badge>
	</div>
	<p class="text-right overline mb-0 pb-0" >{{ task.created.toDate() | moment("HH:mm D/MM/YYYY") }}</p>
</v-alert>
</template>

<script type="text/javascript">

	export default {
		name: "TaskTile", 
		props: {
			task: {type: Object}, 
			truncate: {type: Boolean, default: () => true }
		},
		computed: {
			notes(){
				return this.task.notes ? this.task.notes.length : 0;
			},
			snippet(){

				if( !this.truncate || this.task.text.length < 94 ){
					return this.task.text
				}
				return this.task.text.substr(0, 94) + "..."
			}
		},
		methods: {
			color(task){
				if( task.priority == "high" ){
					return "red";
				}
				return "#ccc"
			},
		}
	}
</script>